import React from 'react';
import { Card, Tag, Typography } from 'antd';
import MathJaxHTMLContent from "../../../common/MathJaxHTMLContent";

const { Text } = Typography;

const TestQuestion = (props) => {
    const {testQuestion, contentClassName = '', questionResult, questionNumber, showUserAnswers = false, showExamCitations = false, tagText, onChange, onKeyUp} = props;

    if(testQuestion == undefined) {
        return <div className="ch-error-text">Invalid question</div>
    }

    const insertQuestionAnswers = (questionResult, questionContent) => {
        if(questionResult == undefined || questionContent == undefined || !showUserAnswers) {
            return;
        }

        const $questionContent = $(questionContent);
        inlineQuestions.insertAnswers($questionContent, questionResult, questionResult.feedback);
        $('input, textarea, select', $questionContent).prop('disabled', true);
    };

    return (
        <Card
            key={testQuestion.questionId}
            className="margin-t--m margin-b--m"
            size="small"
            title={
                <div className={'flex smallGap'}>
                    <strong>Question {questionNumber}</strong>
                    {showUserAnswers &&
                        <>{questionResult && questionResult.result ? <Tag color="green">Correct</Tag> : <Tag color="red">Incorrect</Tag>}</>
                    }
                    {tagText &&
                        <Tag color="purple">{tagText}</Tag>
                    }
                    {showExamCitations && testQuestion.examCitations && (
                        <strong style={{marginLeft: 8}} className="fontSmall">
                            [{testQuestion.examCitations}]
                        </strong>
                    )}
                    {testQuestion.nonCalculator && (
                        <img
                            src="/users/generalFiles/images/noCalculator.svg"
                            title="Do not use a calculator"
                            alt="Do not use a calculator"
                            style={{marginLeft: 8, width: 24, height: 'auto'}}
                        />
                    )}
                </div>
            }
        >
            <MathJaxHTMLContent
                className={'js-question js-react-question ' + contentClassName}
                data-question-id={testQuestion.questionId}
                data-question={testQuestion.questionId}
                html={testQuestion.formattedInstructions}
                onChange={onChange}
                onKeyUp={onKeyUp}
                refCallBack={(questionContent) =>
                    insertQuestionAnswers(questionResult, questionContent)
                }
            />

            {showUserAnswers && questionResult && questionResult.result == false && ['TEXTFIELD', 'RADIO', 'CHECKBOX'].includes(testQuestion.questionAnswerType) && (
                <div style={{ marginTop: 10 }}>
                    <Text strong>User Answer: </Text>
                    <Text code>{questionResult.userInput || 'None'}</Text>
                    &nbsp;
                    <Text strong>Correct Answer: </Text>
                    <Text code>{questionResult.correctAnswer || 'N/A'}</Text>
                </div>
            )}
        </Card>
    );
};

export default TestQuestion;
